import type { JSX } from "react";
import { DownloadIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { ThemedIconButton } from "@vega-core/components/Buttons/ThemedIconButton";
import { useDeviceWidth } from "@vega-core/hooks/useDeviceWidth";
import { m } from "@vega-core/paraglide/messages";

import {
  type TableActionButtonConfig,
  TableActionType,
  type TableFilterId,
} from "../types";

export function RenderAction({
  action,
  isLoading,
  tableId,
}: {
  action: TableActionButtonConfig;
  isLoading: boolean;
  tableId: TableFilterId;
}): JSX.Element {
  const iconOnly = !useDeviceWidth("md");

  switch (action.type) {
    case TableActionType.Button:
      return (
        <ThemedButton
          {...action.props}
          dataTestId={
            action.props.dataTestId || `${tableId}-action-button-${action.id}`
          }
        />
      );
    case TableActionType.IconButton:
      return (
        <ThemedIconButton
          {...action.props}
          dataTestId={
            action.props.dataTestId ||
            `${tableId}-action-icon-button-${action.id}`
          }
        />
      );
    case TableActionType.Export:
      return (
        <ThemedButton
          disabled={action.props.disabled || isLoading}
          icon={<DownloadIcon />}
          iconPosition="right"
          isLoading={action.props.isLoading || isLoading}
          variant="secondary"
          {...action.props}
          dataTestId={
            action.props.dataTestId || `${tableId}-export-button-${action.id}`
          }
        >
          {iconOnly ? null : (action.props.children ?? m.btn_export())}
        </ThemedButton>
      );
    case TableActionType.Custom:
      return action.component;
  }
}
